import GraweLogo from "src/assets/images/brands/grawe.svg";
import WienerLogo from "src/assets/images/brands/wiener.svg";
import config from "src/config";

export const BrandLogos = () => [
  {
    code: "grawe",
    logo: GraweLogo,
  },
  {
    code: "wiener",
    logo: WienerLogo,
  }
]

export type BrandCode = ReturnType<typeof BrandLogos>[number]["code"];

export const getBrandLogo = (brandCode: BrandCode, ptsLogo?: string | null) => {
  const brandLogo = BrandLogos().find((brand) => brand.code === brandCode);

  if (!brandLogo && ptsLogo) {
    return `${config.REACT_APP_BRAND_URL}/${ptsLogo}`;
  }

  return brandLogo?.logo;
};